import { userStorageKey } from '#layers/base/public';

/**
 * The last workspace a user was in, in localStorage keyed by user id so two accounts sharing a
 * browser never read each other's slug. Plain get/set — the callers (workspace middleware, backdrop
 * resolver) touch it once and never render from it, so there's no reactive state to keep in sync.
 * Off the client it reads null and writes nothing, never an unscoped key.
 */
export function readLastWorkspace(userId: string): string | null {
	if (!import.meta.client) return null;
	return localStorage.getItem(userStorageKey(userId, 'last-workspace'));
}

export function writeLastWorkspace(userId: string, slug: string): void {
	if (!import.meta.client) return;
	localStorage.setItem(userStorageKey(userId, 'last-workspace'), slug);
}
